import { datadogRum } from '@datadog/browser-rum';

export class MonitoringService {
  setUser(user: { userId: string; customerId: string; name: string; email: string; role: string; }): void {
    datadogRum.setUser(user);
  }

  setGlobalContextProperty(name: string, value: any): void {
    datadogRum.setGlobalContextProperty(name, value);
  }

  sendEvent(eventName: string, data?: any): void {
    datadogRum.addAction(eventName, data);
  }

  addError(error: Error, data: object): void {
    datadogRum.addError(error, data);
  }
}
